import * as Icon from "@ant-design/icons";
import { Modal, Form, Row, Col, Select, Flex } from "antd";
import Search from "antd/es/input/Search";
import { ColumnsType } from "antd/es/table";
import * as PhosphorIcon from "phosphor-react";
import { useState, useEffect } from "react";
import { AtivoModel } from "../../models/ativoModel";
import { AtualizarPlanoContaFinanceiroRedutorModel } from "../../models/planoContaFinanceiro/atualizarPlanoContaFinanceiroRedutorModel";
import { PlanoContaFinanceiroDTOModel } from "../../models/planoContaFinanceiro/planoContaFinanceiroDTOModel";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import {
  setEntityPlanoContaFinanceiro,
  setBuscaPlanoContaFinanceiro,
  setModalCadastrarPlanoContaFinanceiro,
  setModalDeletarPlanoContaFinanceiro,
  setModalHistoricoPlanoContaFinanceiro,
} from "../../redux/slices/planoContaFinanceiro/planoContaFinanceiroSlice";
import { atualizarPlanoContaFinanceiroAtivo, atualizarPlanoContaFinanceiroRedutor, buscarPlanoContaFinanceiro, deletarPlanoContaFinanceiro } from "../../services/planoContaFinanceiroService";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import HistoricoPlanoContaFinanceiro from "./modals/historico";
import CadastroEdicaoPlanoContaFinanceiro from "./modals/cadastrar";
import { buscarGrupoPlanoContaFinanceiro } from "../../services/grupoPlanoContaFinanceiroService";
import MensagemModal from "../../components/modal/mensagem";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import { ButtonComponent } from "../../components/button/cadastrar";
import { BuscaPlanoContaFinanceiroModel } from "../../models/planoContaFinanceiro/buscaPlanoContaFinanceiroModel";
import AcoesComponent from "../../components/table/acoesComponent";
import { GrupoPlanoContaFinanceiroModel } from "../../models/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroModel";
import TableComponent from "../../components/table/tableComponent";
import { removeFilhos } from "../../util/functions/removeFilhos";
import { SwitchComponent } from "../../components/button/switch";

const PlanoContaFinanceiro = () => {
  //estados globais
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);
  const grupoPlanoContaFinanceiroState = useAppSelector((state) => state.grupoPlanoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const [idPlanoCadastro, setIdPlanoCadastro] = useState<number>(0);

  let watchIdGrupoPlanoContaFinanceiro = Form.useWatch("idGrupoPlanoContaFinanceiro", form);

  const editar = Object.values(planoContaFinanceiroState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("PLANO DE CONTA FINANCEIRO"));
    dispatch(buscarGrupoPlanoContaFinanceiro(grupoPlanoContaFinanceiroState.busca));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityPlanoContaFinanceiro({}));
    dispatch(setModalCadastrarPlanoContaFinanceiro(true));
  };

  const goEditar = (value: PlanoContaFinanceiroDTOModel) => {
    dispatch(setEntityPlanoContaFinanceiro(value));
    dispatch(setModalCadastrarPlanoContaFinanceiro(true));
  };

  const goCadastroLinha = (value: PlanoContaFinanceiroDTOModel) => {
    setIdPlanoCadastro(value.id);
    goCadastrar();
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarPlanoContaFinanceiro(false));
  };

  const goDeletar = (value: PlanoContaFinanceiroDTOModel) => {
    dispatch(setEntityPlanoContaFinanceiro(value));
    dispatch(setModalDeletarPlanoContaFinanceiro(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarPlanoContaFinanceiro(false));
  };

  const goHistorico = (value: any) => {
    dispatch(setEntityPlanoContaFinanceiro(value));
    dispatch(setModalHistoricoPlanoContaFinanceiro(true));
  };

  const closeModalHistorico = () => {
    dispatch(setModalHistoricoPlanoContaFinanceiro(false));
  };

  const onChangeAtivo = (value: PlanoContaFinanceiroDTOModel) => {
    let args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarPlanoContaFinanceiroAtivo({ value: args, busca: planoContaFinanceiroState.busca }));
  };

  const onChangeRedutor = (value: PlanoContaFinanceiroDTOModel) => {
    let args: AtualizarPlanoContaFinanceiroRedutorModel = {
      id: value.id,
      redutor: !value.redutor,
    };
    dispatch(atualizarPlanoContaFinanceiroRedutor({ value: args, busca: planoContaFinanceiroState.busca }));
  };

  const onSearch = (value: string) => {
    let busca: BuscaPlanoContaFinanceiroModel = { ...planoContaFinanceiroState.busca, pesquisar: value };
    dispatch(buscarPlanoContaFinanceiro(busca));
    dispatch(setBuscaPlanoContaFinanceiro(busca));
  };

  const onChangeGrupo = (value: number) => {
    let busca: BuscaPlanoContaFinanceiroModel = { ...planoContaFinanceiroState.busca, idGrupoPlanoContaFinanceiro: value };

    dispatch(setBuscaPlanoContaFinanceiro(busca));
    dispatch(buscarPlanoContaFinanceiro(busca));
  };

  const onChangeTable = (pagination: any, filters: any) => {
    let busca: BuscaPlanoContaFinanceiroModel = { ...planoContaFinanceiroState.busca };
    if (filters.ativo !== null) {
      if (filters.ativo.length === 2) {
        busca.ativo = null;
      }
      if (filters.ativo.length === 1) {
        if (filters.ativo[0] === "true") {
          busca.ativo = true;
        }
        if (filters.ativo[0] === "false") {
          busca.ativo = false;
        }
      }
    } else {
      busca.ativo = null;
    }
    dispatch(setBuscaPlanoContaFinanceiro(busca));
    dispatch(buscarPlanoContaFinanceiro(busca));
  };

  const itemsFilho: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
    {
      label: "Histórico da conta",
      key: "3",
      icon: <PhosphorIcon.ChartLine size={16} color="#212937" weight="light" />,
      function: (item: any) => goHistorico(item),
    },
  ];

  const itemsPai: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Histórico da conta",
      key: "2",
      icon: <PhosphorIcon.ChartLine size={16} color="#212937" weight="light" />,
      function: (item: any) => goHistorico(item),
    },
    { type: "divider" },
    {
      label: "Cadastrar a partir desse plano",
      key: "3",
      icon: <Icon.PlusCircleOutlined />,
      function: (item: any) => goCadastroLinha(item),
    },
  ];

  const columns: ColumnsType<PlanoContaFinanceiroDTOModel> = [
    {
      title: "PLANO DE CONTA",
      dataIndex: "denominacaoCompleta",
    },
    {
      title: "DESCRIÇÃO",
      dataIndex: "descricao",
    },
    {
      title: "GRUPO PLANO CONTA FINANCEIRA",
      dataIndex: "denominacaoGrupoPlano",
      align: "center",
    },
    {
      title: "TIPO",
      dataIndex: "receitaDespesa",
      align: "center",
      render: (_, record) => (record.receitaDespesa.toLowerCase() === "r" ? "Receita" : "Despesa"),
    },
    {
      title: "CONTA REDUTORA",
      dataIndex: "redutor",
      align: "center",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => (record.idPai === null ? "" : <SwitchComponent onChange={() => onChangeRedutor(record)} checked={record.redutor} />),
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      defaultFilteredValue: ["true" as any],
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => (record.idPai === null ? "" : <SwitchComponent onChange={() => onChangeAtivo(record)} checked={record.ativo} />),
    },
    {
      title: "INTERNO",
      dataIndex: "usoSistema",
      align: "center",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => (record.idPai === null ? "" : <SwitchComponent checked={record.usoSistema} disabled />),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => record.idPai !== null && <AcoesComponent record={record} items={record.sinteticoAnalitico.toLowerCase() === "s" ? itemsPai : itemsFilho} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form} onFinish={goCadastrar}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item
                label="Grupo de plano de conta financeiro"
                name="idGrupoPlanoContaFinanceiro"
                rules={[
                  {
                    required: true,
                    message: "Campo obrigatório",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Selecione um grupo"
                  loading={grupoPlanoContaFinanceiroState.loading}
                  onChange={onChangeGrupo}
                  options={grupoPlanoContaFinanceiroState.list.map((a: GrupoPlanoContaFinanceiroModel) => ({
                    value: a.id,
                    label: a.denominacao,
                  }))}
                />
              </Form.Item>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search
                  allowClear
                  placeholder="Plano de conta financeiro ou Descrição"
                  onSearch={onSearch}
                  className="searchInput"
                  enterButton
                  disabled={watchIdGrupoPlanoContaFinanceiro === undefined}
                  style={{ width: 400 }}
                />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent htmlType="submit" />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        loading={planoContaFinanceiroState.loading}
        data={removeFilhos(planoContaFinanceiroState.list)}
        columns={columns}
        expandable={{
          childrenColumnName: "filhos",
          expandRowByClick: true,
        }}
        tableProps={{
          className: "tableCentroCusto",
          onChange: onChangeTable,
        }}
      />
      <Modal
        title={editar ? "EDITAR PLANO DE CONTA FINANCEIRO" : "NOVO PLANO DE CONTA FINANCEIRO"}
        centered
        width={1300}
        open={planoContaFinanceiroState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroEdicaoPlanoContaFinanceiro idPlanoCadastro={idPlanoCadastro} />
      </Modal>
      <Modal title={"HISTÓRICO DO PLANO DE CONTA FINANCEIRO"} centered width={1100} open={planoContaFinanceiroState.modalHistorico} onCancel={closeModalHistorico} footer={null} destroyOnHidden>
        <HistoricoPlanoContaFinanceiro />
      </Modal>
      <Modal title={"REMOVER PLANO DE CONTA FINANCEIRO"} centered width={350} open={planoContaFinanceiroState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o plano de conta financeira?"
          action={deletarPlanoContaFinanceiro({ value: planoContaFinanceiroState.entity.id, busca: planoContaFinanceiroState.busca })}
          close={setModalDeletarPlanoContaFinanceiro(false)}
        />
      </Modal>
    </Flex>
  );
};

export default PlanoContaFinanceiro;
